module.exports = __webpack_public_path__ + "static/media/bone.ca8077f8.svg";